/*global chrome*/
import React, { Component } from "react";
import { connect } from "react-redux";

import Loader from "../../../../../../../components/loader";
import EmptyLoader from "../../../../../../../components/emptyLoader";

import { withRouter } from "react-router";
import { compose } from "redux";
import Moment from "moment";
import axios from "axios";

{
  /* 
1 - user signed up info 
2 -   Users Installed Dependencies
3 -  Skill Executions
4 - Skills Created/Added
5- total skillset info
6- total skills 
7-total creators
8-total users
9- total teams
10- active creators
11- skill status info 

*/
}

class ApproveHelper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userList: [],
      skillList: [],
      start_date: null,
      end_date: null,
    };
  }

  componentDidMount() {
    this.prepareFetch();
    // this.getUsers();
  }
  componentWillUnmount() {
    this.setState({
      isLoading: false,
      userList: [],
      skillList: [],
      start_date: null,
      end_date: null,
    });
  }

  prepareFetch = async () => {
    this.setState({
      isLoading: true,
    });
    var defaultStartDate = new Date();
    var defaultEndDate = new Date();
    defaultEndDate.setDate(defaultEndDate.getDate() + 1);
    defaultStartDate.setDate(defaultStartDate.getDate() - 7);

    var searchDate = this.props.location.search.split("&");
    let queryLen = searchDate?.length;
    let startDate = searchDate[queryLen - 2];
    let endDate = searchDate[queryLen - 1];

    let _dStart = startDate ? startDate : defaultStartDate;
    let _dEnd = endDate ? endDate : defaultEndDate;

    this.setState({ isLoading: true });

    const checkOrg = this.props.location.search.split("&");
    const orgId = checkOrg[0].split("orgId=")[1];
    const email = this.props?.userReducer?.user?.email;
    const isAdmin =
      process.env.REACT_APP_ADMIN1 === email ||
      process.env.REACT_APP_ADMIN2 === email ||
      process.env.REACT_APP_ADMIN3 === email ||
      process.env.REACT_APP_ADMIN4 === email
        ? true
        : false;
    const org = isAdmin ? null : orgId;
    await this.fetchData(this.formatDate(_dStart), this.formatDate(_dEnd), org);
    this.setState({ isLoading: false });
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  fetchData = async (
    start = null,
    end = null,
    orgId = null,
    loadData = true
  ) => {
    var userList;
    var skillList;
    var payload = {
      start_date: start == null ? "2022-01-11" : start,
      end_date: end == null ? Moment().format("YYYY-MM-DD") : end,
      orgId,
      loadData,
    };
    var id = this.props.match.params.id;
    const instance = axios.create({
      baseURL: process.env.REACT_APP_ECS_HOST_URL + "/analytics/",
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: false,
    });
    if (id == 1 || id == 2 || id == 3 || id == 4) {
      const dashboardCards = await instance.post(`topmetrics`, payload);
      if (dashboardCards.status) {
        this.setState({
          userList: dashboardCards.data?.data[id]?.usersInfo || dashboardCards.data?.data[id]?.usersSkillInfo,
          isLoading: false,
        });
      } else {
        this.setState({
          userList: [],
          isLoading: false,
        });
      }
    } else if (id == 5) {
      //load skillset info
      // Total number of skillsets
      const getSkillSets = await instance.post(`getSkillSet`, payload);
      let skillData = getSkillSets?.data?.data[0]?.skillSetInfo[0];
      if (getSkillSets.status) {
        this.setState({
          skillList: skillData,
          isLoading: false,
        });
      } else {
        this.setState({
          skillList: [],
          isLoading: false,
        });
      }
    } else if (id == 6) {
      //load skill info

      const skillStatus = await instance.post(`getSkillStatus`, payload);
      let skillData = skillStatus?.data?.data[0]?.skillInfo;

      if (skillStatus.status) {
        this.setState({
          skillList: skillData,
          isLoading: false,
        });
      } else {
        this.setState({
          skillList: [],
          isLoading: false,
        });
      }
    } else if (id == 7) {
      //total creators
      var checkOrg = this.props.location.search.split("&");
      var orgId = checkOrg[0].split("orgId=")[1];
      let topcreatorsList;
      if (orgId) {
        topcreatorsList = await instance.post(`topcreators`, {
          start_date: start == null ? "2022-01-11" : start,
          end_date: end == null ? Moment().format("YYYY-MM-DD") : end,
          orgId,
          loadData,
        });
      } else {
        topcreatorsList = await instance.post(`topcreators`, payload);
      }
      if (topcreatorsList.status) {
        this.setState({
          userList: topcreatorsList.data.data,
          isLoading: false,
        });
      } else {
        this.setState({
          userList: [],
          isLoading: false,
        });
      }
    } else if (id == 8) {
      //total users
      const totalUser = await instance.post(`getUsers`, payload);
      if (totalUser.status) {
        this.setState({
          userList: totalUser.data?.data[0]?.usersInfo,
          isLoading: false,
        });
      } else {
        this.setState({
          userList: [],
          isLoading: false,
        });
      }
    } else if (id == 9) {
      //total teams info
      const teamsData = await instance.post(`getTeams`, payload);
      this.setState({
        userList: teamsData.data?.data[0]?.teamInfo,
        isLoading: false,
      });
    } else if (id == 10) {
      const activeCreators = await instance.post(`getActiveCreator`, payload);
      if (activeCreators.status) {
        this.setState({
          userList: activeCreators.data?.data[0]?.creatorsInfo,
          isLoading: false,
        });
      } else {
        this.setState({
          userList: [],
          isLoading: false,
        });
      }
    } else if (id == 11) {
      const result = await instance.post(`hoursSaved`, payload);
      let skillData = result?.data?.data?.skillInfo;
      if (result.status) {
        this.setState({
          skillList: skillData,
          isLoading: false,
        });
      } else {
        this.setState({
          skillList: [],
          isLoading: false,
        });
      }
    } else if (id == 12) {
      var checkOrg = this.props.location.search.split("&");
      var orgId = checkOrg[0].split("orgId=")[1];
      const skillStatus = await instance.post(`getTeamSkill`, {
        start_date: start == null ? "2022-01-11" : start,
        end_date: end == null ? Moment().format("YYYY-MM-DD") : end,
        orgId,
        loadData,
      });
      let skillData = skillStatus?.data?.data;
      if (skillStatus.status) {
        this.setState({
          skillList: skillData,
          isLoading: false,
        });
      } else {
        this.setState({
          skillList: [],
          isLoading: false,
        });
      }
    }
  };

  getUserInfoScreen = () => {
    return (
      <div className="fw-screen">
        <div className={false ? "right-content rm-margin" : "right-content"}>
          <div className="task-col">
            <div className="title-btn">
              <h1 className="title">User Information</h1>
            </div>

            <div
              id="scrollableDiv"
              className="scrollable tl-scroll task-tb-scroll"
              style={{ height: "75vh" }}
            >
              {this.state.isLoading ? (
                <Loader
                  styles={{ width: "50px", margin: "auto" }}
                  root={{ display: "flex" }}
                />
              ) : this.state?.userList?.length == 0 ? (
                <EmptyLoader message="No Data found" />
              ) : (
                <div className="tab-content task-tabs ">
                  <div id="waiting" className="tab-pane fade in active">
                    <div className="table-responsive tt-block">
                      <table className=" table-striped table table-task">
                        {this.props.match.params.id == 9 ? (
                          <thead>
                            <tr>
                              <th style={{ width: "12%" }}>Id</th>
                              <th style={{ width: "30%" }}>User Id</th>
                              <th style={{ width: "12%" }}>Display Name</th>
                              {/* <th style={{ width: "12%" }}>Name</th> */}
                              <th style={{ width: "20%" }}>Email</th>
                            </tr>
                          </thead>
                        ) : (
                          <>
                            {this.props.match.params.id == 7 ? (
                              <>
                                <thead>
                                  <tr>
                                    <th style={{ width: "30%" }}>User Id</th>

                                    <th style={{ width: "20%" }}>Email</th>
                                    <th style={{ width: "12%" }}>
                                      OrganizationId
                                    </th>
                                  </tr>
                                </thead>
                              </>
                            ) : (
                              <>
                                <thead>
                                  <tr>
                                    <th style={{ width: "30%" }}>User Id</th>
                                    <th style={{ width: "12%" }}>First Name</th>
                                    <th style={{ width: "12%" }}>Last Name</th>
                                    <th style={{ width: "20%" }}>Email</th>
                                  </tr>
                                </thead>
                              </>
                            )}
                          </>
                        )}

                        {this.props.match.params.id == 9 ? (
                          <tbody>
                            {this.state.userList?.map((user, i) => (
                              <tr key={i}>
                                <td>{user.id}</td>
                                <td>{user.user_id}</td>
                                <td>{user.displayName}</td>
                                {/* <td>{user.name}</td> */}
                                <td>{user.email}</td>
                              </tr>
                            ))}
                          </tbody>
                        ) : (
                          <>
                            {this.props.match.params.id == 7 ? (
                              <>
                                <tbody>
                                  {this.state.userList?.map((user, i) => (
                                    <tr key={i}>
                                      <td>{user.user_id}</td>
                                      <td>{user.email}</td>
                                      <td>{user.organization_id}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </>
                            ) : (
                              <>
                                {console.log(this.state.userList, "USER LIST")}
                                <tbody>
                                  {this.state.userList?.map((user, i) => (
                                    <tr key={i}>
                                      <td>{user.id}</td>
                                      <td>{user.first_name}</td>
                                      <td>{user.last_name}</td>
                                      <td>{user.email}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </>
                            )}
                          </>
                        )}
                      </table>
                    </div>
                  </div>
                  {/* )} */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  getSkillInfoScreen = () => {
    var skillFilter = this.props.location.search.split("?status=")[1];
    return (
      <div className="fw-screen">
        <div className={false ? "right-content rm-margin" : "right-content"}>
          <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Agent Information</h1>
            </div>
            <div
              id="scrollableDiv"
              className="scrollable tl-scroll task-tb-scroll"
              style={{ height: "75vh" }}
            >
              {this.state.isLoading ? (
                <Loader
                  styles={{ width: "50px", margin: "auto" }}
                  root={{ display: "flex" }}
                />
              ) : this.state.skillList?.length === 0 ? (
                <EmptyLoader message="No Data found" />
              ) : (
                <div className="tab-content task-tabs ">
                  <div id="waiting" className="tab-pane fade in active">
                    <div className="table-responsive tt-block">
                      <table className=" table-striped table table-task">
                        <thead>
                          <tr>
                            <th style={{ width: "12%" }}>Agent Id</th>
                            <th style={{ width: "20%" }}>Agent Name</th>
                            {
                              this.props.match.params.id == 11 ? (
                                <>
                                  <th style={{ width: "30%" }}>Build ID</th>
                                </>
                              ) : null
                              // <th style={{ width: "30%" }}>
                              //   Skill Description
                              // </th>
                            }

                            <th style={{ width: "30%" }}>Status</th>

                            <th style={{ width: "12%" }}>OrganizationId</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state?.skillList?.length > 0 &&
                            this.state.skillList
                              ?.filter((s, i) => {
                                if (!skillFilter) {
                                  return s;
                                } else if (skillFilter === s.status) {
                                  return s;
                                }
                              })
                              .map((skill, i) => (
                                <tr key={i}>
                                  <td>{skill.id}</td>
                                  <td>{skill.SKILL_NAME}</td>
                                  {
                                    this.props.match.params.id == 11 ? (
                                      <td>{skill.uuid}</td>
                                    ) : null
                                    // <td>{skill.SKILL_DESCRIPTION}</td>
                                  }
                                  <td>{skill.status}</td>
                                  <td>{skill.organizationId}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* )} */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  getScreen = (screen) => {
    switch (screen) {
      case "1":
        return this.getUserInfoScreen();
      case "2":
        return this.getUserInfoScreen();
      case "3":
        return this.getUserInfoScreen();
      case "4":
        return this.getUserInfoScreen();
      case "5":
        return this.getSkillInfoScreen();
      case "6":
        return this.getSkillInfoScreen();
      case "7":
        return this.getUserInfoScreen();
      case "8":
        return this.getUserInfoScreen();
      case "9":
        return this.getUserInfoScreen();
      case "10":
        return this.getUserInfoScreen();
      case "11":
        return this.getSkillInfoScreen();
      case "12":
        return this.getSkillInfoScreen();
    }
  };

  render() {
    return <>{this.getScreen(this.props.match.params.id)}</>;
  }
}

const mapStateToProps = (state) => ({
  knowledge: state.knowledgeReducer,
  user: state.userReducer,
  skill: state.skillReducer,
  analytics: state.analyticsReducer,
});

export default compose(withRouter, connect(mapStateToProps, {}))(ApproveHelper);
